import Logo from "@/components/Logo";
import { NavbarList } from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Menu } from "lucide-react";

export function DialogMenu() {
  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button className="sm:hidden" size="icon" variant="outline">
          <Menu />
        </Button>
      </SheetTrigger>
      <SheetContent side="left" className="p-0 w-nav">
        <div className="flex flex-col h-full">
          <div className="px-4 py-4">
            <Logo className="w-32" />
          </div>
          <div className="flex-1 overflow-hidden">
            <NavbarList collapsed={false} />
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
